import type { TSize } from './types';

export function rotationScale(naturalSize: TSize, rootSize: TSize, rotationDeg: number): number {
  if (!naturalSize?.width || !naturalSize?.height || !rootSize?.width || !rootSize?.height) {
    return 1;
  }

  const { width: naturalWidth, height: naturalHeight } = naturalSize;
  const { width: rootWidth, height: rootHeight } = rootSize;

  const scale0 = Math.min(rootWidth / naturalWidth, rootHeight / naturalHeight); // 0/180
  const scale90 = Math.min(rootWidth / naturalHeight, rootHeight / naturalWidth);
  const currentScale = (rotationDeg % 180 === 0) ? scale0 : scale90;

  return scale0 / currentScale;
}
